import React, {useEffect, useState} from "react"
import PropTypes from 'prop-types'
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Button,
  Alert,
  Spinner
} from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import { addNewItem as onAddNewItem } from "store/products/actions"
import { editItem as onEditItem } from "store/products/actions"
import { getCategoriesAndSubCategories as onGetCategoriesAndSubCategories } from "store/products/actions"
import { editItemDirect as onEditItemDirect } from "helpers/backend_helper"
import { addNewItemDirect as onAddItemDirect } from "helpers/backend_helper"
import { showSuccessToast } from "helpers/function_helper"

const AddNewCategory = props => {
  const dispatch = useDispatch()

  const [validation, setValidation] = useState({
    categoryName: null,
  })
  const [categoryName, setCategoryName] = useState('')
  const [showLoading, setShowLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    if(props.isEdit){
      setCategoryName(props.detailsForEdit.categoryName)
    }
  }, [props.detailsForEdit])

  useEffect(() => {
    setTimeout(() => {
      document.getElementById('productcode').focus();
      document.getElementById('productcode').select();
    }, 250);
    if(props.enteredText != ''){
      setCategoryName(props.enteredText)
    }
  }, [props.enteredText])

  const onChangeValidation = (fieldName, value) => {
    const modifiedV = { ...validation }
    if (value !== "") {
      modifiedV[fieldName] = true
    } else {
      modifiedV[fieldName] = false
    }
    setValidation(modifiedV)
  }

  function validateForm(){
    setErrorMessage('')
    const modifiedV = { ...validation }
    let formValid = true;
    if(categoryName && categoryName != ""){
      modifiedV["categoryName"] = true
    }
    else{
      modifiedV["categoryName"] = false
      formValid = false
    }
    setValidation(modifiedV)
    return formValid
  }

  async function addItem() {
    const formValid = validateForm()
    if(formValid){
      setShowLoading(true)
      const response = await onAddItemDirect({
          'inputValue' : categoryName
        }, 'Category')

      setShowLoading(false)

      if(response.status == 'success'){
        dispatch(onGetCategoriesAndSubCategories(false))
        props.newlyAddedValue(response.confirmation_code)
        showSuccessToast('Added Successfully!!!')
      }
      else if(response.status == 'failure'){
        setErrorMessage(response.errorResponse)
      }
    }
  }

  async function editItem() {
    const formValid = validateForm();
    if(formValid){
      setShowLoading(true)
      const response = await onEditItemDirect({
          'id': props.detailsForEdit.categoryId,
          'value' : categoryName
        }, 'Category')

      setShowLoading(false)

      if(response.status == 'success'){
        dispatch(onGetCategoriesAndSubCategories(false))
        props.newlyAddedValue(response.confirmation_code)
        showSuccessToast('Edited Successfully!!!')
      }
      else if(response.status == 'failure'){
        setErrorMessage(response.errorResponse)
      }
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="wizard clearfix">
                    <Form>
                      {errorMessage !== '' ? <Alert color="danger">{errorMessage}</Alert> : null}
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="productcode">
                              Category Name
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="productcode"
                              maxLength="100"
                              value={categoryName}
                              onChange={event => {
                                onChangeValidation("categoryName", event.target.value.trim())
                                setCategoryName(event.target.value)
                              }}
                              invalid={
                                validation["categoryName"] !== true &&
                                validation["categoryName"] !== null
                              }
                            />
                            {(validation["categoryName"] === false) &&
                              <div className="custom-error">
                                Please enter a Category
                              </div>
                            }
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="d-inline-block float-end">
                            {(showLoading) && <Spinner style={{ width: '2.2rem', height: '2.2rem' }} className="me-3 mt-3" color="primary" />}
                            {props.isEdit === true ? 
                            <Button
                              color="info"
                              className="btn w-lg mt-3 float-end btn-info "
                              onClick={() => {
                                editItem()
                              }}
                              disabled={showLoading}
                              >
                                EDIT
                            </Button>
                            :
                            <Button
                              color="info"
                              className="btn w-lg mt-3 float-end btn-info "
                              onClick={() => {
                                addItem()
                              }}
                              disabled={showLoading}
                              >
                                ADD
                            </Button>
                            }
                            </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

AddNewCategory.propTypes = {
  newlyAddedValue: PropTypes.func,
  detailsForEdit: PropTypes.any,
  isEdit:PropTypes.bool,
  enteredText:PropTypes.any,
}

export default AddNewCategory
